module.exports = __webpack_public_path__ + "static/media/BSHARE.bc72c486.svg";